import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import {
  validaSoloNumero,
  formatMoneda,
  validaNumeroTelefono,
  validaEmail,
} from "../../../util/varios";
import CatalogoUsuarioWeb from "../../../catalogos/catalogoUsuarioWeb";
import "react-tabs/style/react-tabs.css";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import useTableFijo from "../../useTableFijo";
import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import moment from "moment";
import { hex_md5 } from "../../../util/Md5";
import axios from "axios";

import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../../ui/buttons/Button";
import { Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";

export const ActualizarAgenteRetencion = (props) => {
  let op = require("../../../../src/modulos/datos");
  let heightTabla = 320;
  const headCells = [
    {
      id: "idfactura",
      label: "PLANILLA",
      width: "30px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "fechaenterami",
      label: "FECHA RETENCIÓN",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "periodo",
      label: "PERIODO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "numrete",
      label: "N° RETENCIONES",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "montorete",
      label: "MONTO RETENCIONES",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "descristatus",
      label: "STATUS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
  ];
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [visible, setVisible] = useState("hidden");
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const idusuario = localStorage.getItem("idusuario");
  const [contar1, setContar1] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [operacion, setOperacion] = useState("0");
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [localPage, setLocalPage] = useState(0);
  const [localRowsPerPage, setLocalRowsPerPage] = useState(5);
  useEffect(() => {
    setLocalPage(0);
  }, [records.length]);
  let token = localStorage.getItem("jwtToken");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  /* variables Ref */
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdComercio = useRef();
  const cmbRif = useRef("");
  const txtRif = useRef();
  const txtRitm = useRef();
  const txtFechaInscripcion = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const txtTlfContri = useRef();
  const txtEmailContri = useRef();
  const txtCredito = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();
  const txtObserStatus = useRef();
  const txtCodigoUsu = useRef();
  const txtLogin = useRef();
  const txtNombreUsu = useRef();

  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    heightTabla
  );

  const procesarAgente = () => {
    let endpoint = `${op.conexion}/api/industria/actualizaragentereten`;
    let body;
    body = {
      operacion: operacion,
      nid:
        txtIdComercio.current.value === "" ? "0" : txtIdComercio.current.value,
      ritm1:
        operacion === 1
          ? "0"
          : txtRitm.current.value.toString().trim() === ""
            ? "0"
            : txtRitm.current.value.toString().trim().replace("AA-", ""),
      denomi: txtDenominacionCome.current.value.trim().toUpperCase(),
      direc: txtDireccionContri.current.value.trim().toUpperCase(),
      rif1: cmbRif.current.value + txtRif.current.value,
      cedrep: txtCedula.current.value,
      telef: txtTlfContri.current.value,
      fecins: txtFechaInscripcion.current.value,
      stat: parseInt(cmbStatus.current.value),
      obser: txtObserStatus.current.value.toUpperCase(),
      operacionper: operacionPer,
      cor: txtEmailContri.current.value,
      ctlf1: txtTlfRespon.current.value,
      ctlf2: txtCelRespon.current.value,
      ape: txtApellidoRespon.current.value.trim(),
      dir: txtDireccionRespon.current.value.trim(),
      fnac:
        txtFechaNac.current.value !== "" ? txtFechaNac.current.value : moment.utc(),
      nac: cmbNacionalidad.current.value,
      nombres: txtNombreRespon.current.value.trim(),
      sex: cmbSexo.current.value,
      mail: txtEmailContri.current.value,
    };
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (declaWeb) {
            CrearMovimientosWeb(response.data.nid, "agenteretencion"); //estsa lista
          }
          CrearBitacora(response.data.agenteretencion_act, "agenteretencion");
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El agente " +
                response.data.nid +
                " ha sido registrado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El agente " +
                response.data.nid +
                " ha sido modificado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El agente " +
                response.data.nid +
                " ha sido eliminado de manera satisfactoria.",
              icono: "exito",
            });
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtNombreRespon.current.value = "";
          txtApellidoRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailRespon.current.value = "";
          txtTlfRespon.current.value = "";
          txtCelRespon.current.value = "";
          txtFechaNac.current.value = "";
          cmbNacionalidad.current.value = "V";
          cmbSexo.current.value = "M";
          setHabilitadoNR(true);
          if (response.data !== "") {
            setHabilitadoNR(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = response.data.fnacimiento;
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "ERROR",
              texto: "No Existe la Persona, Realice su Registro",
              icono: "error",
            });
            setActivate(false);
            setOperacionPer(1);
            setHabilitadoNR(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosUsuW = (id) => {
    let endpoint = `${op.conexion}/api/consultaweb/usuarioweb?idagente=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log("response.data", response.data);
          if (response.data.length > 0) {
            txtCodigoUsu.current.value = response.data[0].idusuarioweb;
            txtLogin.current.value = response.data[0].login;
            txtNombreUsu.current.value = response.data[0].nombre;
            datosTablaUsuW(response.data[0].idcomercio);
          } else {
            txtCodigoUsu.current.value = "";
            txtLogin.current.value = "";
            txtNombreUsu.current.value = "";
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: "El Usuario no existe",
                icono: "error",
              });
            }
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosTablaUsuW = (id) => {
    let endpoint = `${op.conexion}/api/consultaweb/usuariowebagreten?iduser=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setRecords(response.data);
          } else {
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: "El Usuario no existe",
                icono: "error",
              });
            }
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const crearMovimientoWeb = (codigo, tabla) => {
    let endpoint = `${op.conexion}/api/industria/createmovimientosweb`;
    let body;
    setActivate(true);

    body = {
      nombretabla: tabla,
      operacion: operacion,
      idtabla: codigo,
      fechamovimiento: fechaSistema,
      rif: cmbRif.current.value + txtRif.current.value,
      operacionper: operacionPer,
      actualizado: false,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setVisible("hidden");
    setOperacionPer(0);
    setTitulo("");
    setMsg("");
    setActivate(false);
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const validarUsuarioWeb = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosUsuW(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const CambiarClave = (event) => {
    event.preventDefault();
    if (txtCodigoUsu.current.value !== "") {
      var Clave_crip = hex_md5(cmbRif.current.value + txtRif.current.value);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Cambiar Clave",
        texto: "debe ingresar el codigo del usuario",
        icono: "informacion",
      });
    }
  };

  const CrearMovimientosWeb = (codigo, tabla) => {
    if (codigo !== "") {
      var Clave_crip = hex_md5(cmbRif.current.value + txtRif.current.value);
      crearMovimientoWeb(codigo, tabla);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "usuario asociado",
        texto: "debe ingresar el codigo del usuario",
        icono: "informacion",
      });
    }
  };

  const CrearBitacora = (codigo, tabla) => {
    var tipope;
    if (operacion == 1) {
      tipope = "INCLUIR";
    } else if (operacion == 2) {
      tipope = "EDITAR";
    } else {
      tipope = "ELIMINAR";
    }
    if (codigo !== "") {
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Informaciòn",
        texto: "debe ingresar el codigo del usuario",
        icono: "informacion",
      });
    }
  };

  const procesarSolicitud = () => {
    setActivate(true);
    procesarAgente();
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarSolicitud();
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreRespon.current.value = nomPer;
    txtApellidoRespon.current.value = apePer;
    txtDireccionRespon.current.value = direPer;
    txtEmailRespon.current.value = correoPer;
    txtTlfRespon.current.value = tlf1Per;
    txtCelRespon.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    setOperacionPer(0);
  };

  const handleCloseCatalogoUsuW = () => {
    setMostrar6(false);
  };

  const handleAceptaCatalogoUsuW = (login, nomUsuW, idUsuW) => {
    setMostrar6(false);
    txtCodigoUsu.current.value = idUsuW;
    txtLogin.current.value = login;
    txtNombreUsu.current.value = nomUsuW;
    txtCodigoUsu.current.focus();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  useEffect(() => {
    if (props.operacion === 1 && contar1 === 0) {
      setContar1(1);
    }
  });

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputRitm") {
        cmbRif.current.focus();
      } else if (event.target.id === "inputLetraRif") {
        txtRif.current.focus();
      } else if (event.target.id === "inputRif") {
        txtFechaInscripcion.current.focus();
      } else if (event.target.id === "inputFechaInscripcion") {
        txtDenominacionCome.current.focus();
      } else if (event.target.id === "inputDenoComer") {
        txtDireccionContri.current.focus();
      } else if (event.target.id === "inputDireccionContri") {
        txtTlfContri.current.focus();
      } else if (event.target.id === "inputTlfContri") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtEmailContri.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número telefonico invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          }
        }
      } else if (event.target.id === "inputEmailContri") {
        if (txtEmailContri.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "notificación",
            texto: "Introduzca un E-mail Valido.",
            icono: "informacion",
          });
        } else if (txtEmailContri.current.value.indexOf("@") == -1) {
          setMensaje({
            mostrar: true,
            titulo: "notificación",
            texto: "el E-mail debe tener un formato valido.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputNomResponsable") {
        txtApellidoRespon.current.focus();
      } else if (event.target.id === "inputApeResponsable") {
        txtDireccionRespon.current.focus();
      } else if (event.target.id === "inputDireResponsable") {
        txtEmailRespon.current.focus();
      } else if (event.target.id === "inputEmailResponsable") {
        if (txtEmailRespon.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "notificación",
            texto: "Introduzca un E-mail Secundario Valido.",
            icono: "informacion",
          });
        } else if (txtEmailRespon.current.value.indexOf("@") == -1) {
          setMensaje({
            mostrar: true,
            titulo: "notificación",
            texto: "el E-mail debe tener un formato valido.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "notificación",
              texto: "Formato de número telefonico invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtCelRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "notificación",
              texto: "Formato de número telefonico invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      } else if (event.target.id === "inputNumRegistro") {
        txtFechaInscripcion.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputTlfContri") {
        valido = validaNumeroTelefono(event.target.value);
        if (!valido) {
          setTitulo("Información");
          setMsg("Formato de número telefonico invalido.");
          event.target.value = "";
        }
      } else if (event.target.id === "inputEmailContri") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtCedula.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            event.target.value = "";
          } else {
            if (visible) {
              txtCredito.current.focus();
            } else {
              txtCedula.current.focus();
            }
          }
        }
      } else if (event.target.id === "inputEmailResponsable") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtCelRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (cmbRif.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto:
          "Por Favor Indique el Tipo de Persona en el Registro de Información Fiscal (RIF)",
        icono: "informacion",
      });
      sigue = false;
      cmbRif.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto:
          "El Numero de Registro de Información Fiscal (RIF) no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtFechaInscripcion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Debe Introducir la Fecha de Inscripción de la Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtFechaInscripcion.current.focus();
    } else if (txtDenominacionCome.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "La Denominación Comercial no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDenominacionCome.current.focus();
    } else if (txtDireccionContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "La Dirección de la Empresa no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionContri.current.focus();
    } else if (txtTlfContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Debe Introducir el Nº de Telefono de la Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtTlfContri.current.focus();
    } else if (txtEmailContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Introduzca un E-mail Valido.",
        icono: "informacion",
      });
      sigue = false;
      txtEmailContri.current.focus();
    } else if (txtEmailContri.current.value.indexOf("@") == -1) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "el E-mail debe tener un formato valido.",
        icono: "informacion",
      });
      sigue = false;
      txtEmailContri.current.focus();
    } else if (cmbStatus.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Debe seleccionar un Status",
        icono: "informacion",
      });
      sigue = false;
      cmbStatus.current.focus();
    } else if (
      cmbStatus.current.value.trim() !== "51" &&
      txtObserStatus.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Debe Introducir una Observación del Status",
        icono: "informacion",
      });
      sigue = false;
      txtObserStatus.current.focus();
    } else if (
      txtCedula.current.value.trim() === "" &&
      parseInt(operacionPer) === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "La cedula no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (
      txtNombreRespon.current.value.trim() === "" &&
      parseInt(operacionPer) === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Los nombres no deben estar vacios",
        icono: "informacion",
      });
      sigue = false;
      txtNombreRespon.current.focus();
    } else if (
      txtApellidoRespon.current.value.trim() === "" &&
      parseInt(operacionPer) === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "Los Apellidos no deben estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtApellidoRespon.current.focus();
    } else if (
      txtDireccionRespon.current.value.trim() === "" &&
      parseInt(operacionPer) === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "La direccion del responsable no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionRespon.current.focus();
    } else if (
      txtFechaNac.current.value.trim() === "" &&
      parseInt(operacionPer) === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "notificación",
        texto: "La fecha de nacimiento no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaNac.current.focus();
    }
    if (sigue) {
      ConfirmarOperacion();
    }
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoUsuW = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar6(true);
    }
  };

  const cerrarModal = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
  };

  const ConfirmarOperacion = () => {
    setTitulo("");
    if (operacion === 1) {
      setMensajesino({
        mostrar: true,
        titulo: "Corfirmar",
        texto: "Esta seguro de registrar el agente con estos datos?",
        icono: "informacion",
      });
    } else if (operacion === 2) {
      setMsg("");

      setMensajesino({
        mostrar: true,
        titulo: "Corfirmar",
        texto: "Esta seguro de modificar el agente con estos datos?",
        icono: "informacion",
      });
    } else if (operacion === 3) {
      setMensajesino({
        mostrar: true,
        titulo: "Corfirmar",
        texto: "Esta seguro de eliminar el agente con estos datos?",
        icono: "informacion",
      });
    }
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    if (props.operacion) {
      setOperacion(props.operacion);
      if (props.operacion === 1 && props.espiritu === 9) {
      }
    }
  }, [props.comercio, props.operacion]);

  const imprimirRetencion = (factura) => (event) => {
    event.preventDefault();
    var reporte = "PlanillaRetencionAcarigua";

    window.open(
      op.reportes +
      "reporte=" +
      reporte +
      "&id=" +
      factura.trim() +
      "&viene=" +
      props.espiritu +
      "&factura=" +
      factura.replace("R", ""),
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.operacion === 2) {
          setVisible("visible");
        }

        if (props.operacion !== 1) {
          cmbSexo.current.value =
            props.representante && props.representante.sexo
              ? props.representante.sexo
              : "M";
        }
        console.log("usuario web:", props.usuarioweb);
        datosUsuW(props.comercio.idagenteretencion);
        props.operacion === 3
          ? btnAcepta.current.focus()
          : txtRif.current.focus();
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setDeclaWeb(props.declaweb);
        cmbNacionalidad.current.value = props.representante
          ? props.representante.nacionalidad
          : "";
        cmbSexo.current.value = props.representante
          ? props.representante.sexo
          : "";
        cmbStatus.current.value = props.comercio ? props.comercio.status : "";
        cmbRif.current.value =
          props.comercio && isNaN(props.comercio.rif.substring(0, 1))
            ? props.comercio.rif.substring(0, 1)
            : "";
        setContar1(0);
      }}
    >
      <Modal.Header className="m-0 px-3 py-2 azulGradiant text-light">
        <h3 className='fw-bold m-0' style={{ fontSize: "1.25rem" }}>
          {operacion === 1
            ? "Agregar Agente de Retención. - Actividad Economica"
            : operacion === 2
              ? "Editar Agente de Retención. - Actividad Economica"
              : operacion === 3
                ? "Eliminar Agente de Retención. - Actividad Economica"
                : "Consultar Agente de Retención. - Actividad Economica"}
        </h3>
        <a type='button'
          ref={btnCancela}
          className='fw-bold text-light fs-6'
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="p-2">
        <div className="tipo-letra">
          <ul className="nav " id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Datos Generales
              </a>
            </li>
            {Boolean(props.declaweb) === true ? (
              <li className="nav-item" role="presentation">
                <a
                  className=" rounded nav-link bg-blue-200 text-light"
                  disabled={operacion === 1 ? true : false}
                  id="deuda-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#deuda"
                  type="button"
                  role="tab"
                  aria-controls="deuda"
                  aria-selected="false"
                  style={{
                    fontFamily: "Times New Roman, Times, serif",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Relación de Retenciones
                </a>
              </li>
            ) : (
              ""
            )}
          </ul>
          <div className="tab-content m-0 mt-1 p-0" id="myTabContent">
            <div
              className="tab-pane fade show active m-0 p-0"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className="row m-0 mb-2 p-0">
                <div className="col-6 col-lg-2 p-0 pr-2">
                  <Input label='Código:'
                    disabled={true}
                    ref={txtIdComercio}
                    defaultValue={
                      props.comercio ? props.comercio.idagenteretencion : ""
                    }
                    id="inputCodigo"
                  />
                </div>
                <div className="col-6 col-lg-2 p-0 pr-2">
                  <Input label='RITM:'
                    disabled={true}
                    ref={txtRitm}
                    defaultValue={
                      props.comercio
                        ? props.comercio.ritm !== null
                          ? props.comercio.ritm.trim()
                          : ""
                        : ""
                    }
                    id="inputRitm"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-12 col-lg-4 p-0 pr-2 d-flex">
                  <Select label='RIF:'
                    disabled={deshabilitado}
                    ref={cmbRif}
                    id="inputLetraRif">
                    <option selected value="J">J</option>
                    <option value="V">V</option>
                    <option value="G">G</option>
                    <option value="E">E</option>
                    <option value="P">P</option>
                  </Select>
                  <Input
                    disabled={deshabilitado}
                    ref={txtRif}
                    maxLength={14}
                    placeholder="123456789"
                    id="inputRif"
                    defaultValue={
                      props.comercio &&
                        isNaN(props.comercio.rif.substring(0, 1))
                        ? props.comercio.rif.substring(
                          1,
                          props.comercio.rif.trim().length
                        )
                        : props.comercio &&
                          !isNaN(props.comercio.rif.substring(0, 1))
                          ? props.comercio.rif.substring(
                            0,
                            props.comercio.rif.trim().length
                          )
                          : ""
                    }
                  />
                </div>
                <div className="col-12 col-lg-4 p-0 pr-2">
                  <Input label='Fecha Inscripción:'
                    type="date"
                    disabled={deshabilitado}
                    ref={txtFechaInscripcion}
                    defaultValue={
                      props.comercio
                        ? props.comercio.fechainscripcion !== null
                          ? moment.utc(props.comercio.fechainscripcion).format(
                            "YYYY-MM-DD"
                          )
                          : ""
                        : ""
                    }
                    id="inputFechaInscripcion"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
              <div className="row m-0 mb-2 p-0">
                <div className="col-6 col-lg-2 p-0 pr-2">
                  <Select label='Estatus:'
                    disabled={deshabilitado}
                    ref={cmbStatus}
                    defaultValue={
                      props.comercio
                        ? props.comercio.status !== null
                          ? props.comercio.status
                          : ""
                        : ""
                    }
                  >
                    {props.statuscome && props.statuscome.map((sta) => (
                      <option key={sta.idstatus} value={sta.idstatus}>
                        {sta.descripcion.trim()}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-6 col-lg-3 p-0 pr-2">
                  <Input label='Teléfono:'
                    disabled={deshabilitado}
                    ref={txtTlfContri}
                    id="inputTlfContri"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.comercio
                        ? props.comercio.telefono !== null
                          ? props.comercio.telefono.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-6 col-lg-3 p-0 pr-2">
                  <Input label='Email:'
                    disabled={deshabilitado}
                    ref={txtEmailContri}
                    id="inputEmailContri"
                    defaultValue={
                      props.comercio
                        ? props.comercio.email !== null
                          ? props.comercio.email.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-12 col-lg-4 p-0 pr-2">
                  <Input label='Denominación Comercial:'
                    disabled={deshabilitado}
                    ref={txtDenominacionCome}
                    defaultValue={
                      props.comercio ? props.comercio.nombre.trim() : ""
                    }
                    id="inputDenoComer"
                    onKeyUp={handleInputChange}
                  />
                </div>
              </div>
              <div className="row m-0 mb-2 p-0">
                <div className="col-12 col-lg-6 p-0 pr-2">
                  <Textarea label='Dirección:'
                    style={{ height: 70 }}
                    disabled={deshabilitado}
                    ref={txtDireccionContri}
                    id="inputDireccionContri"
                    defaultValue={
                      props.comercio
                        ? props.comercio.direccion !== null
                          ? props.comercio.direccion.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-12 col-lg-6 p-0 pr-2">
                  <Textarea label='Observación:'
                    style={{ height: 70 }}
                    disabled={deshabilitado}
                    ref={txtObserStatus}
                    id="inputCodActividad"
                    defaultValue={
                      props.comercio ? props.comercio.observacionstatus : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
              <fieldset className="col-12 m-0 p-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Responsable</legend>
                <div className="row m-0 mb-2 p-0">
                  <div className="col-12 col-lg-4 p-0 pr-2 d-flex">
                    <Select label='Cédula:'
                      disabled={!habilitadoNR}
                      ref={cmbNacionalidad}
                      defaultValue={
                        props.representante &&
                        props.representante.nacionalidad
                      }
                    >
                      <option value="V">V</option>
                      <option value="E">E</option>
                    </Select>
                    <SearchInput
                      disabled={deshabilitado}
                      ref={txtCedula}
                      id="inputCedula"
                      defaultValue={
                        props.representante ? props.representante.cedula : ""
                      }
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      onClickButton={catalogoPer}
                      disabledButton={deshabilitado}
                    />
                  </div>
                  <div className="col-6 col-lg-4 p-0 pr-2">
                    <Input label='Nombres:'
                      disabled={!habilitadoNR}
                      ref={txtNombreRespon}
                      id="inputNomResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.nombres.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-6 col-lg-4 p-0 pr-2">
                    <Input label='Apellidos:'
                      disabled={!habilitadoNR}
                      ref={txtApellidoRespon}
                      id="inputApeResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.apellidos.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
                <div className="row m-0 mb-2 p-0">
                  <div className="col-12 col-lg-6 p-0 pr-2">
                    <Input label='Dirección:'
                      disabled={!habilitadoNR}
                      ref={txtDireccionRespon}
                      id="inputDireResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.direccion.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-12 col-lg-6 p-0 pr-2">
                    <Input label='Correo Electronico:'
                      disabled={!habilitadoNR}
                      ref={txtEmailRespon}
                      id="inputEmailResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.correoe !== null
                            ? props.representante.correoe.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <div className="col-6 col-lg-3 p-0 pr-2">
                    <Input label='Telefono:'
                      disabled={!habilitadoNR}
                      ref={txtTlfRespon}
                      id="inputTlfResponsable"
                      placeholder="0000-0000000"
                      defaultValue={
                        props.representante
                          ? props.representante.tlf1 !== null
                            ? props.representante.tlf1.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-6 col-lg-3 p-0 pr-2">
                    <Input label='Celular:'
                      disabled={!habilitadoNR}
                      ref={txtCelRespon}
                      id="inputCelResponsable"
                      placeholder="0000-0000000"
                      defaultValue={
                        props.representante
                          ? props.representante.tlf2 !== null
                            ? props.representante.tlf2.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-6 col-lg-4 p-0 pr-2">
                    <Input label='Fecha de Nacimiento:'
                      type="date"
                      disabled={!habilitadoNR}
                      ref={txtFechaNac}
                      id="inputFechaNac"
                      max={fechaSistema}
                      defaultValue={
                        props.representante
                          ? props.representante.fnacimiento !== null
                            ? moment.utc(props.representante.fnacimiento).format(
                              "YYYY-MM-DD"
                            )
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-6 col-lg-2 p-0 pr-2">
                    <Select label='Sexo:'
                      name=""
                      disabled={!habilitadoNR}
                      ref={cmbSexo}
                      defaultValue={
                        props.representante ? props.representante.sexo : ""
                      }
                    >
                      <option value="M">M</option>
                      <option value="F">F</option>
                    </Select>
                  </div>
                </div>
              </fieldset>
            </div>
            <div
              className="tab-pane fade m-0 p-0"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <fieldset className="col-12 m-0 pt-1 px-2 pb-2 border-azul rounded">
                {/* TODO - NO HAY PERMISOS PARA HACER ESTO */}
                <legend className="float-none w-auto m-0" style={{ lineHeight: 1.2 }}>
                  Usuario Asociado
                </legend>
                <div className="row m-0 p-0">
                  <div className="col-6 col-lg-3 p-0 pr-2">
                    <SearchInput label='Código:'
                      disabled
                      ref={txtCodigoUsu}
                      id="inputLogin"
                      defaultValue={
                        props.usuarioweb && props.usuarioweb.length > 0
                          ? props.usuarioweb.idusuarioweb
                          : ""
                      }
                      onKeyUp={validarUsuarioWeb}
                      onBlur={validarUsuarioWeb}
                      onClickButton={catalogoUsuW}
                      disabledButton={deshabilitado}
                    />
                  </div>
                  <div className="col-6 col-lg-4 p-0 pr-2">
                    <Input label='Login:'
                      disabled
                      ref={txtLogin}
                      id="inputLogin"
                      defaultValue={
                        props.usuarioweb && props.usuarioweb && props.usuarioweb.login
                          ? props.usuarioweb?.login.trim()
                          : ""
                      }
                    />
                  </div>
                  <div className={operacion === 4 ? "col-6 col-lg-5 p-0 pr-2" : "col-6 col-lg-3 p-0 pr-2"}>
                    <Input label='Nombre Usuario:'
                      disabled
                      ref={txtNombreUsu}
                      id="inputNomUsuario"
                      defaultValue={
                        props.usuarioweb && props.usuarioweb && props.usuarioweb.nombre
                          ? props.usuarioweb.nombre.trim()
                          : ""
                      }
                    />
                  </div>
                  {operacion !== 4 && (
                    <div className="col-auto m-0 p-0">
                      <DangerButton icon='fa-key' disabled onClick={CambiarClave}>
                        Cambiar Clave
                      </DangerButton>
                    </div>
                  )}
                </div>
              </fieldset>
              <div className="col-12 m-0 mt-2 p-0">
                <TblContainer>
                  <TblHead />

                  <tbody>
                    {records &&
                      records
                        .slice(
                          localPage * localRowsPerPage,
                          localPage * localRowsPerPage + localRowsPerPage
                        )
                        .map((item, index) => (
                          <tr
                            key={item.idfactura + item.periodo}
                            style={{ padding: "0" }}
                          >
                            <td style={{ fontSize: "10px", textAlign: "center" }}>
                              {"R" + item.idfactura}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "center" }}>
                              {moment.utc(item.fechaenterami).format("DD/MM/YYYY")}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "center" }}>
                              {item.periodo}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "right" }}>
                              {item.numrete}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "right" }}>
                              {formatMoneda(
                                item.montorete.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "center" }}>
                              {item.status}
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </TblContainer>
                <TablePagination
                  component="div"
                  page={localPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  rowsPerPage={localRowsPerPage}
                  labelRowsPerPage="Filas por Paginas"
                  count={records.length}
                  onChangePage={(event, newPage) => setLocalPage(newPage)}
                  onChangeRowsPerPage={(event) => {
                    setLocalRowsPerPage(parseInt(event.target.value, 10));
                    setLocalPage(0);
                  }}
                />
                {records.length > localRowsPerPage && (
                  <div className="d-flex justify-content-center m-0 mt-1 p-0">
                    <Pagination
                      size="small"
                      color="primary"
                      shape="rounded"
                      showFirstButton
                      showLastButton
                      page={localPage + 1}
                      count={Math.ceil(records.length / localRowsPerPage)}
                      onChange={(event, value) => setLocalPage(value - 1)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {operacion !== 4 && <>
          {operacion === 3 &&
            <DangerButton onClick={onChangeValidar} icon='fa-trash-alt'>
              Eliminar
            </DangerButton>
          }
          {operacion === 2 &&
            <WarningButton onClick={onChangeValidar} icon='fa-edit'>
              Modificar
            </WarningButton>
          }
          {operacion === 1 &&
            <SuccessButton onClick={onChangeValidar} icon='fa-save'>
              Guardar
            </SuccessButton>
          }
        </>
        }
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <CatalogoUsuarioWeb
        titulo={titulo}
        mensaje={msg}
        show={mostrar6}
        onHideCancelaCatUsuWeb={handleCloseCatalogoUsuW}
        onHideAceptaCatUsuW={handleAceptaCatalogoUsuW}
      />
    </Modal>
  );
};
